import { Component, OnInit, Input } from '@angular/core';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';

export interface BorrowerValuesByAlias {
  [alias: string]: BorrowerValue;
}

import _ from 'lodash';

@Component({
  selector: 'app-monthly-totals-card',
  templateUrl: './monthly-totals-card.component.html',
  styleUrls: ['./monthly-totals-card.component.scss'],
  standalone: false
})
export class MonthlyTotalsCardComponent implements OnInit {
  @Input() bankValues: BorrowerValue[];
  @Input() currencyCode: string;
  @Input() currencySymbol: string;
  @Input() bankConnection: Date;
  @Input() basicStyle: boolean = false;

  bankValuesByAlias: BorrowerValuesByAlias;

  constructor() { }

  ngOnInit(): void {
    this.bankValuesByAlias = _.keyBy(this.bankValues, 'alias');
  }
}
